var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
/**
 * Get all missions for a specific level.
 */
export function getMissions(levelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/missions`);
    });
}
/**
 * Get a specific mission by its ID.
 */
export function getMissionById(levelId, missionId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/missions/${missionId}`);
    });
}
/**
 * Create a new mission for a level.
 */
export function createMission(levelId, missionData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post(`/levels/${levelId}/missions`, missionData);
    });
}
/**
 * Update an existing mission.
 */
export function updateMission(levelId, missionId, missionData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.put(`/levels/${levelId}/missions/${missionId}`, missionData);
    });
}
/**
 * Delete a mission (mark as archived).
 */
export function deleteMission(levelId, missionId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.delete(`/levels/${levelId}/missions/${missionId}`);
    });
}
/**
 * Get all archived missions for a level.
 */
export function getArchivedMissions(levelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/missions/archived`);
    });
}
/**
 * Restore a mission from archive.
 */
export function restoreMission(levelId, missionId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.post(`/levels/${levelId}/missions/${missionId}/restore`);
    });
}
/**
 * Permanently delete a mission.
 */
export function deleteMissionPermanent(levelId, missionId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.delete(`/levels/${levelId}/missions/${missionId}/permanent`);
    });
}
